<template>
    <v-content :style="mini  ? 'padding: 0px 0px 0px 80px;' : 'padding: 0px 0px 0px 256px;'" >
        <v-container class="mt-n8" fluid>
            <v-col cols="12">
                <v-card raised>
                  <v-card-title>{{ documentsdata.gendoc_name }}</v-card-title>
                  <v-card-text>
                    <p>{{ documentsdata.gendoc_description}}</p>

                  <div v-if="this.documentsdata.gendoc_format == 'pdf' || this.documentsdata.gendoc_format == 'video'" class="iframe-container" style="overflow: hidden; padding-top: 47.00%; position: relative;">
                    <iframe v-if="dialogstatus==false && fileURL != null" id="iframemodule" :src="fileURL+'#toolbar=0'" style="border: 0;height: 100%;left: 0; position: absolute; top: 0; width: 100%;" allowfullscreen></iframe>                  
                  </div>
                  </v-card-text>

                </v-card>                
            </v-col>
        </v-container>
        <Dialogbox
          @redirect="redirect"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :closestatus='false'
          :redirect="true"
          v-if="dialogstatus == true"
        />


    </v-content>   
</template>
<script>
import {
  FETCH_DOCUMENT,
  DOWNLOAD_GENERAL_DOCUMENT,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";
import store from "@/store";
import { mapGetters } from "vuex";
export default {
  name: "Documentsdetail",
  async beforeRouteEnter(to, from, next) {
    Promise.all([
       await store.dispatch(RESET_STATE),
       await store.dispatch(FETCH_DOCUMENT, to.params.id),
    ]).finally(() => {
      store.commit(SET_LOADING, false)
      store.commit(SET_ROUTER_ENTER, false)

    });

    return next();
  }, 
  components: {
    Dialogbox: () => import("@/components/dialog/dialog")
  },  
  computed: {
    ...mapGetters(['documentsdata', 'mini', 'widthValue']),
  }, 
  data (){
      return {
          file: null,
          fileURL: null,
          dialogstatus: false,
          dialogButtontitle: null,
          dialogboxtitle: null,
      }
  },
  mounted () {
      if(this.documentsdata.gendoc_format == 'pdf' || this.documentsdata.gendoc_format == 'other'){
        this.$store.dispatch(DOWNLOAD_GENERAL_DOCUMENT, 'view-file/'+this.documentsdata.doc_files[0].docfile_id).then(async resp =>{
          if(resp != undefined && resp.hasOwnProperty('success') == false){
            if(this.documentsdata.doc_files[0].extension == 'pdf'){
            this.file = new Blob([resp.data], {type: 'application/pdf'});
            this.fileURL = URL.createObjectURL(this.file);
            await this.$store.commit(SET_LOADING, false)                  
            }
            else if(['doc','docx','ppt','pptx', 'xlsx'].includes(this.documentsdata.doc_files[0].extension)){
              let file = null;
              if(['ppt','pptx'].includes(this.documentsdata.doc_files[0].extension)){
                file = new Blob([resp.data], {type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'});
              }
              else if(['doc','docx'].includes(this.documentsdata.doc_files[0].extension)){
                file = new Blob([resp.data], {type: 'application/msword'});
              }
              else if(['xlsx'].includes(this.documentsdata.doc_files[0].extension)){
                file = new Blob([resp.data], {type: 'application/octet-stream'});
              }              
              this.fileURL = URL.createObjectURL(file);
              let fileLink = document.createElement('a');
              fileLink.href = this.fileURL;
              fileLink.setAttribute('download', this.documentsdata.doc_files[0].doc_type+'.'+this.documentsdata.doc_files[0].extension);
              document.body.appendChild(fileLink);
              fileLink.click(); 


              await this.$store.commit(SET_LOADING, false)  
            }
            else if(['png','jpg'].includes(this.documentsdata.doc_files[0].extension)){
              this.fileURL = URL.createObjectURL(resp.data);                  
              let fileLink = document.createElement('a');
              fileLink.href = this.fileURL;
              fileLink.setAttribute('download', this.documentsdata.doc_files[0].doc_type+'.'+this.documentsdata.doc_files[0].extension);
              document.body.appendChild(fileLink);
              fileLink.click(); 
              await this.$store.commit(SET_LOADING, false)                    
            }
          }
          else {
            this.dialogstatus=true
            this.dialogboxtitle = 'Please subscribe to course'
            this.dialogButtontitle  = 'Go to courses'
            await this.$store.commit(SET_LOADING, false)   
                           

          }
        })
      }
      else if(this.documentsdata.gendoc_format == 'video'){
          this.fileURL =   this.documentsdata.doc_files[0].file
      }
  },
  methods: {
    redirect(){
      this.$router.push('/courses')
    }
  }
}
</script>